import i18next from 'i18next';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentStatusReason } from '../../hooks';

export const ShipmentStatusReasonSelect = ({
  placeholder = i18next.t('translation:default.fields.reason.placeholder'),
  label = i18next.t('translation:default.fields.reason.label'),
  rules = [],
  name,
  editMode,
  onChange = false,
  margin,
}) => {
  const { data: options = [], isLoading } = useGetShipmentStatusReason();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin ?? 'mb-0'}
      rules={rules}
      name={name}
      editMode={editMode}
      {...(onChange ? { onChange } : {})}
    />
  );
};
